import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faCheck as freeFasFaCheck,
  faCheckCircle as freeFasFaCheckCircle,
  faDice as freeFasFaDice,
  faTimes as freeFasFaTimes,
  faUsers as freeFasFaUsers,
  faUsersSlash as freeFasFaUsersSlash,
  faPoll as freeFasFaPoll,
  faReply as freeFasFaReply,
  faPaperPlane as freeFasFaPaperPlane,
  faCog as freeFasFaCog,
  faTimesCircle as freeFasFaTimesCircle,
  faQuestionCircle as freeFasFaQuestionCircle,
  faTrash as freeFasFaTrash,
  faList as freeFasFaList,
  faInfoCircle as freeFasFaInfoCircle,
  faCaretDown as freeFasFaCaretDown,
  faEnvelopeOpenText as freeFasFaEnvelopeOpenText
} from '@fortawesome/free-solid-svg-icons'

import {
  faCalendarCheck as freeFarFaCalendarCheck,
  faCalendarTimes as freeFarFaCalendarTimes,
  faCheckCircle as freeFarFaCheckCircle,
  faClock as freeFarFaClock,
  faCopy as freeFarFaCopy,
  faTimesCircle as freeFarFaTimesCircle,
  faQuestionCircle as freeFarFaQuestionCircle,
  faHourglass as freeFarFaHourglass,
  faUserCircle as freeFarFaUserCircle,
  faSave as freeFarFaSave,
  faBell as freeFarFaBell,
  faEnvelope as freeFarFaEnvelope
} from '@fortawesome/free-regular-svg-icons'

library.add(
  freeFasFaCheck,
  freeFasFaCheckCircle,
  freeFasFaDice,
  freeFasFaTimes,
  freeFasFaUsers,
  freeFasFaUsersSlash,
  freeFasFaPoll,
  freeFasFaReply,
  freeFasFaPaperPlane,
  freeFasFaCog,
  freeFasFaTimesCircle,
  freeFasFaQuestionCircle,
  freeFasFaTrash,
  freeFasFaList,
  freeFasFaInfoCircle,
  freeFasFaCaretDown,
  freeFasFaEnvelopeOpenText,
  freeFarFaCalendarCheck,
  freeFarFaCalendarTimes,
  freeFarFaCheckCircle,
  freeFarFaClock,
  freeFarFaCopy,
  freeFarFaTimesCircle,
  freeFarFaQuestionCircle,
  freeFarFaHourglass,
  freeFarFaUserCircle,
  freeFarFaSave,
  freeFarFaBell,
  freeFarFaEnvelope
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)
